import axios from 'axios';
import Cookies from 'universal-cookie';

const getAuthHeaders = () => {
  const cookies = new Cookies();
  const token = cookies.get('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildUrl = (path) => {
  const base = window.API_BASE_URL || '';

  // Normaliza para evitar casos como: base='https://host/api' + path='/api/...' => '/api/api/...'
  const normalizedBase = base.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (/\/api$/i.test(normalizedBase) && /^\/api\//i.test(normalizedPath)) {
    return `${normalizedBase}${normalizedPath.replace(/^\/api/i, '')}`;
  }

  return `${normalizedBase}${normalizedPath}`;
};

export const getPreleadsResumen = async (fecha) => {
  return axios.get(buildUrl('/api/venta-directa/reportes/preleads/resumen'), {
    params: { fecha },
    headers: {
      ...getAuthHeaders(),
    },
  });
};

const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;

  // Ejemplos:
  // content-disposition: attachment; filename="file.xlsx"
  // content-disposition: attachment; filename*=UTF-8''file.xlsx
  const filenameStarMatch = /filename\*=UTF-8''([^;\n]+)/i.exec(contentDisposition);
  if (filenameStarMatch?.[1]) {
    try {
      return decodeURIComponent(filenameStarMatch[1].replace(/"/g, ''));
    } catch {
      return filenameStarMatch[1].replace(/"/g, '');
    }
  }

  const filenameMatch = /filename=([^;\n]+)/i.exec(contentDisposition);
  if (filenameMatch?.[1]) return filenameMatch[1].replace(/"/g, '').trim();

  return null;
};

export const downloadPreleadsExcel = async (fecha) => {
  const response = await axios.get(buildUrl('/api/venta-directa/reportes/preleads/excel'), {
    params: { fecha },
    responseType: 'blob',
    headers: {
      ...getAuthHeaders(),
    },
  });

  const contentType = response.headers?.['content-type'] || 'application/octet-stream';
  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);

  const contentDisposition = response.headers?.['content-disposition'];
  const filename =
    getFilenameFromContentDisposition(contentDisposition) || `PreLeadsV2_${fecha}.xlsx`;

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);

  return response;
};
